import { SimpleForm, TextInput } from "react-admin"

export const BillPaymentStatusUpdateForm = () => (
  <SimpleForm>
    <TextInput source="internal_notes" multiline rows={3} />
  </SimpleForm>
)
